import React, { useState, useEffect, useContext } from 'react';

import Button from 'b2b-ui-components-lib/lib/components/button';
import RoundLoader from 'b2b-ui-components-lib/lib/components/roundLoader';

import CancelOrderPopup from 'dedicated/components/cancelOrderPopup/cancelOrderPopup';
import EmailPopup from 'dedicated/components/emailPopup/emailPopup';

import { getFromSessionStorage, handleError, numberWithCommas, showServiceError } from 'common/utils/app.utils';

import './index.scss';
import { GENERIC_ERROR_MESSAGE, isAOIOrder, isBulkUpgrade, isNLD_OR_LL, ORDER_TYPE } from 'common/constants/app.constants';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';
import CustomModal from 'home/view/upgrade-order/components/common/CustomModal';
import { updateOrderForSummary } from 'home/view/manage-feasibility/services';
import { MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import { AppContext } from 'App';

const Footer = (props) => {
  let {
    isFormValid,
    submitOrder,
    updateOrder,
    order,
    isSaveBtnDisabled,
    totalSites = 0,
    isOrderConfirmation = false,
    setNotification = () => {},
    fetchOrder = () => {},
    showEmailPopup = false,
    orderConfirmationPopup = false,
    setShowEmailPopup = () => {},
    setOrderConfirmationPopup = () => {},
    isUpgrade = false,
    customerDetail,
    setCustomerDetail,
    showLoader,
    showAoiKycStep,
    setShowAoiKycStep,
    setIsSaveBtnDisabled,
    updatedEmail,
    formAdd,
    addressAccordionValidator,
    otpVerifyLoader,
    setOtpVerifyLoader
  } = props;
  const totalPrice = order && order.lead && order.lead.planDetail && order.lead.planDetail.totalPrice;

  const { setActiveStep } = useContext(AppContext);

  const { orderStatus, ocLinkSentAtList } = order || {};
  const email = ocLinkSentAtList?.join(', ').toString();

  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [viewMore, setViewMore] = useState(false);

  const onViewMoreLessClick = () => {
    setViewMore(!viewMore);
  };

  const onCancel = () => {
    setShowCancelPopup(true);
  };

  const isOrderConfirmationPending = () => {
    return orderStatus === ORDER_TYPE.ORDER_CONFIRMATION_PENDING;
  };

  const prepareAddressPayload = (formAdd) => {
    const request = {};
    const payload = {};

    request['addressLine1'] = formAdd.address.value;
    request['city'] = formAdd.city.value.displayName;
    request['pinCode'] = formAdd.pinCode.value;

    payload['billingAddress'] = request;

    return payload;
  };

  const updateAddressCallHandler = () => {
    const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
    if (formAdd?.address?.value && formAdd?.city?.value && formAdd?.pinCode?.value) {
      let payload = prepareAddressPayload(formAdd);
      updateOrderForSummary(payload, orderAuthToken).then(
        (res) => {
          let status = res && res.res && res.res.data && res.res.data.success;
          if (status) {
            sendOtpFn();
          } else {
            handleError('');
          }
        },
        (error) => {
          handleError(error);
        }
      );
    }
  };
  const onSubmit = () => {
    if (order?.eligibleForBilling && showAoiKycStep) {
      updateAddressCallHandler();
    } else {
      sendOtpFn();
    }
  };
  const sendOtpFn = () => {
    if (isOrderConfirmationPending()) {
      fetchOrder(isUpgrade ? setOrderConfirmationPopup : setShowEmailPopup);
      if (isUpgrade) {
        setOrderConfirmationPopup(true);
      } else {
        setShowEmailPopup(true);
      }
    } else {
      if (showAoiKycStep) {
        setShowEmailPopup(true);
      } else {
        setShowAoiKycStep(true);
        if (isAOIOrder()) {
          setActiveStep(4);
        }
        setIsSaveBtnDisabled(true);
      }
    }
  };
  const setOTPVerification = (verified) => {
    if (verified) {
      setOtpVerifyLoader(true);
      // setOpacityClass('opacity-class')
      submitOrder();
    }
  };

  useEffect(() => {
    document.getElementById('root').className = 'pricing-strip';
    return () => {
      document.getElementById('root').classList.remove('pricing-strip');
    };
  }, []);

  return (
    <div>
      <div className={`order-footer selected-plans active ${showEmailPopup || showCancelPopup || orderConfirmationPopup ? 'open' : ''}`}>
        <div className={`inside-plan ${viewMore ? 'show_full_view' : ''}`}>
          <div className="plan-info">
            <div className="plan_details_veiw">
              <div className="left_col">
                <h4>Total Amount</h4>
                <div class="value mt-10">&#8377; {totalPrice ? numberWithCommas(totalPrice) : 'N/A'}</div>
              </div>
              <div className="right_col">
                <div className="view_type" onClick={onViewMoreLessClick}>
                  {viewMore ? 'View Less' : 'View More'} <span className={`animatedarrow ${viewMore ? 'arrow_up' : ''} `}></span>
                </div>
              </div>
            </div>
            <div className="condition_info">Including 18% Taxes.</div>
          </div>
          <div className="plan-details">
            <div className={`item_list ${isAOIOrder() ? 'visibility_hidden' : ''}`}>
              <div className="items tital_for_mobile">
                <div className="label">{isNLD_OR_LL() ? 'Total Links in Order' : 'Total Sites in Order'}</div>
                <div className="value">
                  <strong>{totalSites ? totalSites : '-'} </strong>
                </div>
              </div>
              <div className="items total_for_desktop border-bottom">
                <div className="label">{isNLD_OR_LL() ? 'Total Links in Order' : 'Total Sites in Order'}</div>
                <div className="value">
                  <strong>{totalSites ? totalSites : '-'} </strong>
                </div>
              </div>
            </div>

            <div className="action">
              <Button variant="outlinebtn" onClick={onCancel}>
                Cancel
              </Button>
              {isOrderConfirmation ? (
                <Button className="activebtn" onClick={onSubmit}>
                  {!showAoiKycStep ? 'Proceed' : 'Confirm Order'}
                </Button>
              ) : (
                <Button className="activebtn" disabled={!isFormValid || isSaveBtnDisabled || !addressAccordionValidator.isValidated} onClick={onSubmit}>
                  {!showAoiKycStep ? 'Proceed' : 'Confirm Order'}
                </Button>
              )}
            </div>
          </div>
        </div>

        {showCancelPopup && <CancelOrderPopup isUpgrade={isUpgrade} isMultiSite isSummaryPage setshowPopup={setShowCancelPopup} metaData={order}></CancelOrderPopup>}

        {showEmailPopup && (
          <EmailPopup
            isMultiSite
            setshowPopup={setShowEmailPopup}
            email={email}
            setOTPVerification={setOTPVerification}
            orderStatus={orderStatus}
            isOrderConfirmation={isOrderConfirmation && isOrderConfirmationUrl()}
            fetchOrder={fetchOrder}
            setNotification={setNotification}
            customer={customerDetail}
            setCustomerDetail={setCustomerDetail}
            updatedEmail={updatedEmail}
          ></EmailPopup>
        )}
        {orderConfirmationPopup && (
          <CustomModal
            submitOrderPopup
            customPopupTitle="Confirm Order"
            customPopupMsg="Are you sure you want to place the order?"
            submitCustomPopup={() => {
              submitOrder();
            }}
            closeCustomPopup={() => setOrderConfirmationPopup(false)}
            loading={showLoader}
            // leadData={leadData}
          />
        )}
      </div>
    </div>
  );
};

export default Footer;
